module.exports = __webpack_public_path__ + "static/img/Nconsumed-ten.fb351ebb.png";